<mat-card appearance="outlined" class="mat-elevation-z4 mat-card-scrollable">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.Top10Shareholders' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <table mat-table [dataSource]="topShareholders">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>{{ 'General.Id' | translate }}</th>
                        <td mat-cell *matCellDef="let item">{{ item.id }}</td>
                    </ng-container>
                    <ng-container matColumnDef="displayName">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Contact.Name' | translate }}</th>
                        <td mat-cell *matCellDef="let item">
                            {{ item.displayName }}
                            <br />
                            <label class="info">{{ item.city }}</label>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="totalShares">
                        <th mat-header-cell *matHeaderCellDef class="header-align-right">
                            {{ 'Shareholders.TotalShares' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item" class="header-align-right">
                            {{ item.totalShares | slNumber }}
                            <br />
                            <label class="info">{{ item.totalSharesPercent | slNumber: 2 }}%</label>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="totalVotingRights">
                        <th mat-header-cell *matHeaderCellDef class="header-align-right">
                            {{ 'Shareholders.TotalVotingRights' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item" class="header-align-right">
                            {{ item.totalVotingRights | slNumber }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="lastTransactionDate">
                        <th mat-header-cell *matHeaderCellDef class="header-align-right">
                            {{ 'Shareholders.LastTransactionDate' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item" class="header-align-right">
                            {{ item.lastTransactionDate | localizedDate }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="goToView(row)"></tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>
